import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { RenderDocumentPreview } from "../../utility/CommonFunctions";

const ViewDocumentModal = ({ modal, toggle, selectedDocument, renderDocument }) => {

  const renderContent = () => {
    if (renderDocument && typeof renderDocument === "function") {
      return renderDocument(); // renderDocument handles its own selected file
    }

    if (selectedDocument) {
      return RenderDocumentPreview(selectedDocument);
    }

    return <p>No document to preview.</p>;
  };


  return (
    <Modal className="modal-xl" isOpen={modal} toggle={toggle} centered>
      <ModalHeader toggle={toggle}> Document Preview</ModalHeader>

      <ModalBody className="text-center p-2">
        {renderContent()}
      </ModalBody>
    </Modal>
  );
};

export default ViewDocumentModal;
